export default {
    apiKey: "AIzaSyCSMMRCX0kq83EDeDhsi8rqGhoXYxZTFlw",
    authDomain: "qr-bwp.firebaseapp.com",
    projectId: "qr-bwp",
    storageBucket: "qr-bwp.firebasestorage.app",
    messagingSenderId: "554348449739",
    appId: "1:554348449739:web:220bd768f1e33d9170704e",
    measurementId: "G-62QZRD92RX"
}